import type { ReactNode } from 'react';

interface EntityListStateBlockProps {
  children: ReactNode;
}

export function EntityListStateBlock({ children }: EntityListStateBlockProps) {
  return <div className="flex h-40 items-center justify-center">{children}</div>;
}
